/* BASIQ · Vídeos en bucle siempre sin audio: se reproducen al verse y se pausan al salir de pantalla */
(function () {
  if (window.__bpAutoplayReady) return;
  window.__bpAutoplayReady = true;

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          v.muted = true;
          if (en.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.25 })
    : null;

  function setup(root) {
    (root || document).querySelectorAll('[data-bp-autoplay] video').forEach(function (v) {
      if (v.dataset.bpReady === '1') return;
      v.dataset.bpReady = '1';
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.removeAttribute('controls');
      v.addEventListener('volumechange', function () {
        if (!v.muted) v.muted = true;
      });
      if (io) {
        v.setAttribute('preload', 'metadata');
        io.observe(v);
      } else if (v.play) {
        v.play().catch(function () {});
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setup(); });
  } else {
    setup();
  }
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
